import SearchToolbarContainer from 'components/Page/Properties/Part/SearchToolbar/SearchToolbarContainer';

export default SearchToolbarContainer;
